import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.ServiceProviderDocumentEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.ServiceProviderDocumentList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.ServiceProviderDocumentCreate })));

export default { edit, list, create };
